// Deprecated JWT authentication - commented out for potential future reintegration.
// For the moment, we decided to only user Switch-Authentication for
// the first version at least.
// import { LoginComponent } from './views/auth/login/login.component';
// import { LoginGuard } from './core/auth/login.guard';
// import { RegisterComponent } from './views/auth/register/register.component';

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { ProfileComponent } from './views/profile/profile.component';
import { GroupsOverviewComponent } from './views/groups/groups-overview/groups-overview.component';
import { GroupDetailsComponent } from './views/groups/group-details/group-details.component';
import { GroupMaskComponent } from './views/groups/group-mask/group-mask.component';
import { UserReportComponent } from './views/groups/user-report/user-report.component';
import { OverviewComponent } from './views/logs/general/overview/overview.component';
import { AboutComponent } from './views/static/about/about.component';
import { FAQComponent } from './views/static/faq/faq.component';
import { PrivacyStatementsComponent } from './views/static/privacy-statements/privacy-statements.component';
import { ContactComponent } from './views/static/contact/contact.component';
import { ImpressumComponent } from './views/static/impressum/impressum.component';
import { ReportComponent } from './views/report/report.component';
import { DailyOverviewComponent } from './views/logs/daily/daily-overview/daily-overview.component';
import { EntryComponent } from './views/logs/daily/entry/entry.component';
import { LandingPageComponent } from './views/static/landing-page/landing-page.component';
import { RolesGuard } from './core/auth/roles.guard';
import { GroupAdminsComponent } from './views/group-admins/group-admins.component';
import { ConsentGuard } from './core/auth/consent.guard';

const routes: Routes = [
  // { path: 'login', component: LoginComponent, canActivate: [LoginGuard] },
  // { path: 'register', component: RegisterComponent, canActivate: [LoginGuard] },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'group-admins',
    component: GroupAdminsComponent,
    canActivate: [AuthGuard, RolesGuard],
    data: { roles: ['superAdmin'] },
  },
  {
    path: 'group/:id',
    component: GroupDetailsComponent,
    canActivate: [AuthGuard, RolesGuard],
    data: { roles: ['groupAdmin', 'superAdmin'] },
  },
  {
    path: 'group/:groupId/user/:userId/report',
    component: UserReportComponent,
    canActivate: [AuthGuard, RolesGuard],
    data: { roles: ['groupAdmin', 'superAdmin'] },
  },
  {
    path: 'group-mask',
    component: GroupMaskComponent,
    canActivate: [AuthGuard, RolesGuard],
    data: { roles: ['groupAdmin', 'superAdmin'] },
  },
  {
    path: 'group',
    component: GroupsOverviewComponent,
    canActivate: [AuthGuard, RolesGuard],
    data: { roles: ['groupAdmin', 'superAdmin'] },
  },
  { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
  {
    path: 'logs/general',
    component: OverviewComponent,
    canActivate: [AuthGuard, ConsentGuard],
  },
  {
    path: 'logs/daily',
    component: DailyOverviewComponent,
    canActivate: [AuthGuard, ConsentGuard],
  },
  {
    path: 'logs/daily/entry',
    component: EntryComponent,
    canActivate: [AuthGuard, ConsentGuard],
  },
  {
    path: 'report',
    component: ReportComponent,
    canActivate: [AuthGuard, ConsentGuard],
  },
  {
    path: 'about',
    component: AboutComponent,
  },
  {
    path: 'faq',
    component: FAQComponent,
  },
  {
    path: 'contact',
    component: ContactComponent,
  },
  {
    path: 'impressum',
    component: ImpressumComponent,
  },
  {
    path: 'privacy-statements',
    component: PrivacyStatementsComponent,
  },
  {
    path: '',
    component: LandingPageComponent,
    pathMatch: 'full',
  },
  { path: '**', redirectTo: '/' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
